import { Banner, Icon } from '@loadsmart/miranda-react'

export function CallFacilityBanner() {
  return (
    <Banner>
      <Banner.Icon>
        <Icon name="telephone" size="24" />
      </Banner.Icon>
      <Banner.Title>Call facility to confirm appointment</Banner.Title>
      <Banner.Description>
        Make sure to confirm date and time are available before confirming the appointment.
      </Banner.Description>
    </Banner>
  )
}
